import React from 'react';
import { Paper, Box, Typography } from '@mui/material';
const OrderBookTemplate = ({ children, title }) => {
  return (
    <Paper
      sx={{
        mt: 2,
      }}
    >
      <Box
        sx={{
          px: 2,
          py: 1,
          backgroundColor: '#eee',
        }}
      >
        <Typography variant="subtitle1" component="div">
          {title}
        </Typography>
      </Box>

      <Box sx={{ mt: 1, px: 1, pb:1 }}>{children}</Box>
    </Paper>
  );
};

export default OrderBookTemplate;
